import ButtonLoader from 'app/ui_v2/components/button-loader/ButtonLoader';
import { Controller } from 'react-hook-form';

import { FormControl, FormHelperText, Input, InputAdornment, InputLabel } from '@mui/material';

export type BasicTextInputType = 'text' | 'email' | 'number';

export interface BasicTextInputProps {
  label: string;
  helperText?: string;
  control: any;
  inputName: string;
  placeholder?: string;
  type?: BasicTextInputType;
  required?: boolean;
  disabled?: boolean;
  inputComponent?: any;
  inputProps?: any;
  onChange?: any;
  errorsInputName?: string;
  adornment?: { position: 'start' | 'end'; label: string; isLoader?: boolean };
}

export default function BasicTextInput(props: BasicTextInputProps) {
  const {
    control,
    label,
    inputName,
    helperText,
    placeholder,
    type = 'text',
    required,
    disabled = false,
    inputComponent,
    inputProps,
    onChange,
    adornment,
  } = props;

  return (
    <Controller
      name={inputName}
      control={control}
      render={({ field, fieldState }) => (
        <FormControl error={!!fieldState.error}>
          <InputLabel required={required ? true : false} shrink htmlFor={inputName}>
            {label} {}
          </InputLabel>
          <Input
            {...field}
            type={type}
            error={!!fieldState.error}
            placeholder={placeholder}
            disabled={disabled}
            inputComponent={inputComponent}
            inputProps={inputProps}
            onChange={(e) => {
              field.onChange(e);
              onChange && onChange();
            }}
            endAdornment={
              adornment &&
              adornment.position === 'end' && (
                <InputAdornment position="end">
                  {adornment.label}
                  {adornment.isLoader && <ButtonLoader isActive={true} noMargin={true} />}
                </InputAdornment>
              )
            }
            startAdornment={
              adornment &&
              adornment.position === 'start' && (
                <InputAdornment position="start">
                  {adornment.label}
                  {adornment.isLoader && <ButtonLoader isActive={true} noMargin={true} />}
                </InputAdornment>
              )
            }
          />
          {(!!fieldState.error || helperText) && (
            <FormHelperText>{fieldState.error?.message || helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
